/**
 * "Build TBD" — a rep chose "Describe the idea" instead of speccing the build
 * (DD-DESCRIBE-001b), so the submission carries no base substrate. The flag is
 * raised from the frozen spec (originAdapter) and RESOLVED once a human records a
 * base substrate on the line (DD-SUBSTRATE-RESOLVE-001 / F-057) — the attribute
 * is the truth, the spec is history.
 */
import { partsBuildResolved, type LinePart } from '@/lib/dd-queue/lineParts'

export const BUILD_TBD_FLAG = 'Build TBD — D&D determines the build'

/**
 * DD-DESIGN-TBD-001 (F-085) — Design-phase wording for a describe-mode line. Kept next to
 * the flag so the queue, the Attributes card and the HubSpot note say the same thing.
 */
export const TBD_DIMENSION_TEXT = 'Design to determine — see Design brief'

export const TBD_SUBSTRATE_HINT =
  'Not specified by Sales — D&D determines the build. Pick here or at Product Review.'

/**
 * True once the line carries a human/stored base substrate. F-120: with a parts list the parts
 * decide — only Manufactured – In House parts need a stock (mirrors
 * DdWorkflowMutationService::lineBuildResolved).
 */
export function isBuildResolved(
  attributes: Record<string, string> | null | undefined,
  parts?: readonly LinePart[] | null
): boolean {
  if (parts && parts.length > 0) return partsBuildResolved(parts)
  const v = attributes?.base_substrate
  return typeof v === 'string' && v.trim() !== ''
}

/** Drop the Build TBD flag when the build has been resolved on the line. */
export function applyBuildTbdResolution(
  flags: readonly string[],
  attributes: Record<string, string> | null | undefined,
  parts?: readonly LinePart[] | null
): string[] {
  if (!isBuildResolved(attributes, parts)) return [...flags]
  return flags.filter((f) => f !== BUILD_TBD_FLAG)
}
